export enum SubscriptionTopics {
  DEVICE_EVENTS_TOPIC = 'DEVICE_EVENTS',
  KITCHEN_DISPLAY_EVENTS_TOPIC = 'KITCHEN_DISPLAY_EVENTS',
  UPDATE_PRODUCTS_AVAILABILITY_EVENT = 'UPDATE_PRODUCTS_AVAILABILITY_EVENT',
  UPDATE_CUSTOMER_INFO_EVENT = 'UPDATE_CUSTOMER_INFO_EVENT',
  UPDATE_STORE_EVENT = 'UPDATE_STORE_EVENT',
  UPDATE_CATALOGUE_EVENT = 'UPDATE_CATALOGUE_EVENT',
  UPDATE_DEVICE_VERSION = 'UPDATE_DEVICE_VERSION',
}

export enum DeviceEventActions {
  LOGOUT_ACTION = 'LOGOUT',
  UN_PAIR_CDS_ACTION = 'UN_PAIR_CDS',
  PAIR_CDS_ACTION = 'PAIR_CDS',
  CONFIG_UPDATE_ACTION = 'CONFIG_UPDATE',
}

export enum KitchenDisplayActions {
  LOGOUT_ACTION = 'LOGOUT',
}

export enum StoreUpdateEvents {
  UPDATE_STORE_STATUS = 'UPDATE_STORE_STATUS',
  PAUSE_ORDERS = 'PAUSE_ORDERS',
  DELAY_ORDERS = 'DELAY_ORDERS',
}
